export default function EditPanelWarningMessage({ message }: { message: string | false }) {
    if (message == false || message == '') {
        return null;
    }
    return <div>{message}</div>;
}
